import React from 'react';
import './workcard.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'



const WorkCard = ({ work, isHome }) => {
    const links = work.links;


    const iconHandle = (icon) => {
        let fIcon;
        if (icon == 'live') {
            fIcon = <FontAwesomeIcon icon='external-link-alt'/> 
        } else {
            fIcon = <FontAwesomeIcon icon={['fab', icon]} />
        }
        return fIcon;
    }
    
    return (
       
            <div className="work-card">
            <div className="work-flex">
                <div className="left">
                    <img src={work.image} alt="image"/>
                </div>
                <div className="right work-content">
                    <h4>Featured Project</h4>
                    <h3>{work.title}</h3>
                    <p>{isHome && work.content.substring(0, 60)+ '...' || work.content}</p>
                    <div className="language-uses">
                        {
                            work.languages.map(lan => <span className="lan">{lan}</span>)
                        }
                        
                    </div>
                    <div className="links">
                    {
                        links.map(link => <a href={link.link} target="_blank">{iconHandle(link.text)}</a>)
                    }
                    </div>
                </div>
            </div>
        </div>
  
    );
};

export default WorkCard;